<template>
     <v-app>
    <v-container>
         <v-row dense>
        <v-col cols="4" lg='4' sm='12' xs="12">
          <v-card
    class="mx-auto"
    max-width="400"
  >
    <v-img
      height="250px"
      contain
      src="../assets/staticAsset/GSF_Sketch-Family-Color-00.jpg"
    >
     
    </v-img>

    <v-card-text class="text--primary">
       <v-card-title >Family History Collection Guide</v-card-title>
    
    </v-card-text>

    <v-card-actions>
      <v-btn
        color="#eee092"
        text
        to='/familyHistoryCollection'
      >
        View
      </v-btn>

      <v-btn
        color="#eee092"
        text
        @click='downloadPDF("https://storage.googleapis.com/genetictrust-dev.appspot.com/public/Family%20History%20Collection%20Guide.pdf")'
      >
        Download
      </v-btn>
    </v-card-actions>
  </v-card>
        </v-col>

       <v-col cols="4" lg='4' sm='12' xs="12">
          <v-card
    class="mx-auto"
    max-width="425"
  >
    <v-img
      height="250px"
      contain
      src="../assets/staticAsset/GSF_InitialStyleSketches-scientist-green.png"
    >
     
    </v-img>

    <v-card-text class="text--primary">
       <v-card-title >Medical Records Collection Guide</v-card-title>
    
    </v-card-text>

    <v-card-actions>
      <v-btn
        color="#a8c7ab"
        text
        to='/medicalRecordsCollectionGuide'
      >
        View
      </v-btn>

      <v-btn
        color="#a8c7ab"
        text
         @click='downloadPDF("https://storage.googleapis.com/genetictrust-dev.appspot.com/public/Medical%20Records%20Collection%20Guide.pdf")'
      >
        Download
      </v-btn>
    </v-card-actions>
  </v-card>
        </v-col>
           <v-col cols="4" lg='4' sm='12' xs="12">
          <v-card
    class="mx-auto"
    max-width="425"
  >
    <v-img
      height="250px"
      contain
      src="../assets/staticAsset/GSF_Sketch-Couple-Color-00.jpg"
    >
     
    </v-img>

    <v-card-text class="text--primary">
       <v-card-title >Family Tree Worksheet</v-card-title>
    
    </v-card-text>

    <v-card-actions>
      <v-btn
        color="#97c5d1"
        text
        to='/FamilyTreeWorksheet'
      >
        View
      </v-btn>

      <v-btn
        color="#97c5d1"
        text
         @click='downloadPDF("https://storage.googleapis.com/genetictrust-dev.appspot.com/public/My%20Genetic%20Trust%20Family%20Tree%20Worksheet.pdf")'
      >
        Download
      </v-btn>
    </v-card-actions>
  </v-card>
        </v-col>
      </v-row>
    </v-container>
     </v-app>
</template>

<script>
export default {
    data(){
        return{
                   items: [
        {
          text: 'Home',
          disabled: false,
          to: '/home'
        },
        {
          text: 'Resources',
          disabled: true,
        
        }],
        }
    },
    methods : {
      downloadPDF(url){
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.download = name;
      a.target = "blank";
      a.href = url;
      a.click();
    }
    }
    }
</script>

<style>

</style>
